/**
 * External dependencies
 */
import ReactDom from 'react-dom';
import page from 'page';

/**
 * Internal dependencies
 */
import { isUserLoggedIn } from 'state/current-user/selectors';


export function redirectLoggedOut(context, next) {
    const state = context.store.getState();
    const userLoggedOut = !isUserLoggedIn(state);

    if (userLoggedOut) {
        // force full page reload to avoid SSR hydration issues.
        // const queryParameters = new URLSearchParams(window.location.search);
        // const hmac = queryParameters.get("hmac");
        // const host = queryParameters.get("host");
        // const shop = queryParameters.get("shop");
        // const timestamp = queryParameters.get("timestamp");
        // const session = queryParameters.get("session");

        // localStorage.setItem('test', '123');

        // if(hmac !== null && host !== null && 
        //     shop !== null && timestamp !== null) {
            
        //     if(session !== null) {
        //         const redirect = "/sgc/install&hmac="+hmac+"&host="+host+"&session="+session+"&shop="+shop+"&timestamp="+timestamp;
        //         window.location = "/login?redirect="+redirect;
        //     } else {
        //         const redirect = "/sgc/install&hmac="+hmac+"&host="+host+"&shop="+shop+"&timestamp="+timestamp;
        //         window.location = "/login?redirect="+redirect;
        //     }
        // } else {
        //     window.location = "/login";
        // }

        const queryParameters = new URLSearchParams(window.location.search);
        const code = queryParameters.get("code");
        const hmac = queryParameters.get("hmac");
        const host = queryParameters.get("host");
        const shop = queryParameters.get("shop");
        const timestamp = queryParameters.get("timestamp");
        const session = queryParameters.get("session");

        if(hmac !== null && host !== null && 
            shop !== null && timestamp !== null && code !== null) {
            
            if(session !== null) {
                const redirect = "/sgc/callback&code="+code+"&hmac="+hmac+"&host="+host+"&session="+session+"&shop="+shop+"&timestamp="+timestamp;
                window.location = "/login?redirect="+redirect;
            } else {
                const redirect = "/sgc/callback&code="+code+"&hmac="+hmac+"&host="+host+"&shop="+shop+"&timestamp="+timestamp;
                window.location = "/login?redirect="+redirect;
            }
        } else {
            window.location = "/login";
        }

        return;
    }

    next();
}

export function hydrate(context) {
    ReactDom.render(context.layout, document.getElementById('root'));
}

export function render(context) {
    ReactDom.render(context.layout, document.getElementById('root'));
}

export function redirectLoggedIn(context, next) {
    const userLoggedIn = isUserLoggedIn(context.store.getState());

    if (userLoggedIn) {
        page.redirect('/');
        return;
    }

    next();
}